import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * The page's main picture (its first after the logo) loads at once and
 * first. The prerendered HTML already asks for it so (scripts/prerender-head.tsx),
 * but React then draws the page from its code, where every image is lazy, and
 * Lighthouse judges the drawn one. The picture is downloaded by then, so this
 * costs nothing.
 */
export default function EagerFirstImage() {
  const { pathname } = useLocation();
  useEffect(() => {
    const img = [...document.querySelectorAll<HTMLImageElement>("#root img")].find((i) => !/logo/i.test(i.getAttribute("src") ?? ""));
    if (!img) return;
    img.loading = "eager";
    img.setAttribute("fetchpriority", "high");
  }, [pathname]);
  return null;
}
